<template>
	<div class="container__amostrainfo__open">
		<div class="container__amostrainfo__open__title">
			<div style="display: flex; flex-direction: column; gap: 0.3rem">
				<span style="font-size: 0.7rem">{{ $t('sample') }}</span>
				<span>{{ amostraInfo.codigo }}</span>
			</div>
		</div>
		<div class="container__amostrainfo__open__info">
			<div class="container__amostrainfo__open__info__values">
				<span>{{ $t('basalArea') }}</span>
				<span>
					{{ amostraInfo.area ? `${amostraInfo.area} (m²)` : $t('notInformed') }}
				</span>
			</div>
			<div class="container__amostrainfo__open__info__values right">
				<span>{{ $t('installationDate') }}</span>
				<span>
					{{
						amostraInfo.dataDeInstalacao
							? `${new Date(amostraInfo.dataDeInstalacao).toLocaleDateString()}`
							: $t('notInstalled')
					}}</span
				>
			</div>
		</div>
		<div
			style="flex-direction: column"
			class="container__amostrainfo__open__info"
		>
			<div class="container__amostrainfo__open__info__values">
				<span>{{ $t('latitude') }}</span>
				<span> {{ amostraInfo.coordenadaY }}</span>
			</div>
			<div class="container__amostrainfo__open__info__values">
				<span>{{ $t('longitude') }}</span>
				<span> {{ amostraInfo.coordenadaX }}</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AmostraInfo',
	components: {},

	props: {
		/**
		 * Informacoes do marker e do plantio que devem ser colocados no mapa
		 */
		amostraInfo: Object,
	},
}
</script>

<style scoped>
.container__amostrainfo {
	cursor: default;
	font-family: 'Open Sans', sans-serif;
	background-color: transparent;
}

.container__amostrainfo__open {
	padding-top: 0.5rem;
	display: block;
}

.container__amostrainfo__open {
	display: flex;
	flex-direction: column;
	min-width: 20rem;
}

.container__amostrainfo__open__title {
	display: flex;
	font-size: 1.5rem;
	font-weight: 700;
	color: rgb(var(--color-default));
	line-height: 1rem;
}

.container__amostrainfo__open__info {
	display: flex;
	justify-content: space-between;
}

.container__amostrainfo__open__info__values {
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin-top: 1rem;
}

.container__amostrainfo__open__info__values.right {
	align-items: flex-end;
}

.container__amostrainfo__open__info__values > span:first-child {
	font-size: 0.75rem;
	color: var(--color-gray-dark);
	font-weight: 500;
}

.container__amostrainfo__open__info__values > span:nth-child(2) {
	font-size: 1.2rem;
	font-weight: 700;
}

.container__amostrainfo__open__info__values > span:nth-child(2) > span:first-child {
	font-size: 0.75rem;
	font-weight: 500;
}

.container__amostrainfo__open__info__values > span:nth-child(3) {
	background-color: rgba(var(--color-default), 0.2);
	color: rgb(var(--color-default));
	padding: 0 0.5rem;
	border-radius: 10px;
	font-weight: 600;
}

.container__amostrainfo__open__info__poligono {
	height: 5rem;
	width: 5rem;
}

.container__amostrainfo__open__info__progress {
	height: 5px;
	width: 100%;
	background-color: rgba(var(--color-rgb-gray), 0.3);
	border-radius: 25px;
	overflow: hidden;
}

.container__amostrainfo__open__info__progress > div {
	height: 5px;
	background-color: rgb(var(--color-default));
}

.container__amostrainfo__open__action__buttons {
	display: flex;
	margin-top: 0.5rem;
}
</style>
